import { SeriesReport } from './SeriesReport';

export default SeriesReport;
